import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableComponent = _resolveComponent("TableComponent")!

  return (_openBlock(), _createBlock(_component_TableComponent, {
    columns: _ctx.columns,
    storePaths: _ctx.storePaths,
    params: _ctx.filter,
    pagination: _ctx.pagination
  }, null, 8, ["columns", "storePaths", "params", "pagination"]))
}